<template>
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="handelSearch" @handleFilterData="handleFilter" />
    <!--客户搜索筛选框-->
    <!-- <apply-search :show.sync="showFilterPop" @handlequery="handleFqueryFilter" /> -->
    <van-list v-model="loading" :finished="finished"  finished-text="没有更多了" @load="onLoad" v-if="list.length > 0">
      <total-component :totalValue="total" />
      <van-cell v-for="(item, index) in list" :key="index" @click="toDetails(item)">
        <div class="main_box">
          <img src="../../assets/images/desktop/tz.png" alt="">
          <div class="right_detail">
            <div class="name_wrap">{{item.noticeTitle}} <span>{{item.createTime}}</span></div>
            <div class="content" v-html="item.noticeContent.replace('<p>','')">></div>
            <div class="bottom">
              <span>详情</span><van-icon color="#c1c1c1" name="arrow" size="12" />
            </div>
          </div>
        </div>
      </van-cell>
    </van-list>
    <empty-component v-if="isEmpty" />
  </div>
</template>

<script>
import { listNotice } from '@/api/admi/user'
import SearchComponent from '@/components/common/Search'
import EmptyComponent from '@/components/common/Empty'
import TotalComponent from '@/components/common/Total'
import { Toast } from 'vant'
export default {
  name: 'NOTICE',
  components: {
    [Toast.name]: Toast,
    SearchComponent,
    EmptyComponent,
    TotalComponent
  },
  data() {
    return {
      isEmpty: false,
      loading: false,
      finished: false,
      list: [],
      total: 0,
      showFilterPop: false,
      custList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      }
    }
  },
  created() {
    this.handleList()
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      document.title = '通知列表'
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      this.queryParams.noticeTitle = data
      this.queryCustList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      const query = this.queryParams
      this.queryParams = { ...query, ...data }
      this.queryCustList()
      this.showFilterPop = false
    },
    queryCustList() {
      this.list = []
      this.queryParams.pageNum = 1
      this.queryParams.pageSize = 10
      this.handleList()
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    toDetails(item) {
      this.$router.push({
        path: '/shezhi/noticeDetail',
        query: { noticeId: item.noticeId }
      })
    },
    async handleList() {
      this.loading = true
      const res = await listNotice(this.queryParams)

      if (res.code === 200) {
        console.log(res)
        if (res.rows.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.list = this.list.concat(...res.rows)
        this.queryParams.pageNum += 1
        this.total = res.total
        this.finished = this.list.length >= res.total
        this.loading = false
      }
    },
    onLoad() {
      this.handleList()
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.van-tabs {
  position: relative;
  top: 1.25rem;
}
.tips{
  min-width: 3.1rem;
  font-size: .2rem;
  color: rgb(247, 155, 35);
}
/deep/ .van-tabs__line {
    position: absolute;
    bottom: 0.4rem;
    left: 0;
    z-index: 1;
    width: 1.06667rem;
    height: 0.08rem;
    background-color: #0a315d;
    border-radius: 0.08rem;
}
.editVisit{
    min-height: 9rem;
    height: 50%;
    top: 46%;
    .formSty{
      height: 100%; overflow: scroll; margin: 10px 5px;
    }
}
.editVisit /deep/.van-dialog__content {
  height: 83%;
  .van-field--error .van-field__control{
    font-size: 0.38rem;
  }
  .van-field__control{font-size: 0.38rem;}
}
.editVisit /deep/.van-dialog__content {
  height: 70%;
}
.main_box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 30px;
    .right_detail{
      margin-left: 20px;
      position: relative;
      .name_wrap{
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 30px;
        font-weight: bold;
        span{
          font-size: 26px;
          font-weight: 400;
          color: #666;
        }
      }
      .content{
        font-size: 28px;
        color: #999;
      }
      .bottom{
        position: absolute;
        bottom: -40px;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        span{
          margin-right: 10px;
          color: #c4c4c4;
        }
      }
    }
  }
</style>
